import { OfferEntry } from '../../../types/Controlling/OfferEntry'
import useLoadControllingArbeitspakete from './useLoadControllingArbeitspakete'
import useLoadControllingKostenstellen from './useLoadControllingKostenstellen'

const useGetOfferEntryName = (): ((entry: OfferEntry) => string) => {
  const [kostenstellen] = useLoadControllingKostenstellen()
  const [arbeitspakete] = useLoadControllingArbeitspakete()

  if (!!kostenstellen && !!arbeitspakete) {
    return (entry) => {
      const arbeitspaket = arbeitspakete.find((a) => a.uuid === entry.arbeitspaketUUID)
      const kostenstelle = kostenstellen.find((k) => k.uuid === arbeitspaket.kostenstelleUUID)
      return `${arbeitspaket.name} (${kostenstelle.name})`
    }
  } else {
    return () => ''
  }
}

export default useGetOfferEntryName
